import type {Instant, UUID} from './common'
import type {ConstraintSeverity} from './constraint'

/* eslint-disable i18next/no-literal-string -- const definitions are the source of truth */
export const ViolationStatus = {
    OPEN: 'OPEN',
    ACKED: 'ACKED',
    RESOLVED: 'RESOLVED',
} as const;
export type ViolationStatus = typeof ViolationStatus[keyof typeof ViolationStatus];

export const ViolationSubjectTable = {
    PARTIES: 'parties',
    IDENTITIES: 'identities',
    FUNCTION_GROUPS: 'function_groups',
} as const;
export type ViolationSubjectTable = typeof ViolationSubjectTable[keyof typeof ViolationSubjectTable];
/* eslint-enable i18next/no-literal-string */

export interface Violation {
    id: UUID;
    constraintId: UUID;
    detectedAt: Instant;
    severity: ConstraintSeverity;
    status: ViolationStatus;
    message: string;
    context: Record<string, unknown> | null;
    ackedById: UUID | null;
    ackedAt: Instant | null;
    resolvedAt: Instant | null;
    version: number;
    createdAt: Instant;
    updatedAt: Instant;
}

export interface ViolationSummarySubjectRef {
    entityTable: string;
    entityId: UUID;
    label: string | null;
}

export interface ViolationSummary {
    id: UUID;
    constraintId: UUID;
    constraintName: string;
    detectedAt: Instant;
    severity: ConstraintSeverity;
    status: ViolationStatus;
    resolvedAt: Instant | null;
    evalStatus: string | null;
    message: string;
    subjects: ViolationSummarySubjectRef[];
}

/* eslint-disable i18next/no-literal-string -- field-name metamodel constants */
export const ViolationSummaryResponseFields = {
    id: 'id',
    constraintId: 'constraintId',
    constraintName: 'constraintName',
    detectedAt: 'detectedAt',
    severity: 'severity',
    status: 'status',
    resolvedAt: 'resolvedAt',
    evalStatus: 'evalStatus',
    message: 'message',
    subjects: 'subjects',
} as const;
/* eslint-enable i18next/no-literal-string */

export interface AckViolationRequest {
    comment?: string | null;
}

export interface BulkAckRequest {
    ids: UUID[];
    comment?: string | null;
}

export interface BulkActionResultItem {
    id: UUID;
    success: boolean;
    reason: string | null;
}

export interface BulkAction {
    succeeded: number;
    skipped: number;
    results: BulkActionResultItem[];
}

export interface EntityViolationSummary {
    entityTable: string;
    entityId: UUID;
    critical: number;
    error: number;
    warn: number;
    info: number;
    hasReferenceBroken: boolean;
}
